import { ClipboardModule } from '@angular/cdk/clipboard';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslocoModule } from '@jsverse/transloco';
import { Company, CompanyType } from 'app/core/company/company.types';
import { WorkingCompany } from 'app/core/company/working-company';

@Component({
    selector: 'company-tree-side-panel',
    standalone: true,
    imports: [
        CommonModule,
        ClipboardModule,
        MatButtonModule,
        MatIconModule,
        MatTooltipModule,
        TranslocoModule,
    ],
    templateUrl: './company-tree-side-panel.component.html',
})
export class CompanyTreeSidePanelComponent {
    workingCompany = inject(WorkingCompany);

    @Input() mode: 'view' = 'view';
    @Input() company: Company | null = null;

    @Output() closed = new EventEmitter<void>();
    @Output() generateLinkCode = new EventEmitter<void>();
    @Output() actionSelected = new EventEmitter<'delete'>();

    get companyTypeLabelKey(): string {
        switch (this.workingCompany.company.typeCompanyId) {
            case CompanyType.Doorwifi:
                return 'Doorwifi admin';
            case CompanyType.Manusa:
                return 'Manusa admin';
            case CompanyType.Distributor:
                return 'Distributor company';
            case CompanyType.Subdistributor:
                return 'Subdistributor company';
            case CompanyType.Client:
                return 'Client company';
            default:
                return 'Company';
        }
    }
}
